var map = {
	"./AboutPrincipalImageWeb.jpg": "d238",
	"./CCNA-LOGO-lite.png": "5ffc",
	"./CertifiedNet.png": "6d1b",
	"./CertifiedNetPromoWeb.jpg": "4466",
	"./Pearson-vue-semilite.png": "c35e",
	"./ec-council.png": "5832",
	"./ethical-hacking-lite.png": "6ddb",
	"./hero-section-custom.png": "6921",
	"./linux-professional-institute.png": "3871",
	"./microsoft-mcsa.png": "0129",
	"./not-found-image.jpg": "704f",
	"./princial-about-us.jpg": "4f99",
	"./princial-aboutUs.jpg": "cff0",
	"./telegram-courses.png": "6196"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e83";